module.exports = __webpack_public_path__ + "static/mascgb-37e3758c5d74b8eabf5eef2b4c57dcbf.png";